import React, { useState, useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import { showToast } from "../../Helpers/showToast";
import { FileUpload } from "../../Components/Icons/Svgicon";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";
import { ValidateEmail } from "../../Helpers/ValidateEmail";
import TypeCase from "../../Helpers/TypeCase";
import { useSelector, useDispatch } from "react-redux";
import { fetchListDG } from "../../Redux/CommonListData/DesignGroupNameListSlice";
import { fetchListProd } from "../../Redux/CommonListData/ProductNameListSlice";
import { editUserDetail } from "../../Redux/UserDetail/UserDetailSlice";

import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import { Button, IconButton } from "@mui/material";
import Typography from "@mui/material/Typography";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { API_URL } from "../../env";

export default function EditAccount() {
  const [shouldReRender, setShouldReRender] = useState(false);
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const Theme = useSelector((state) => state.Theme);
  const navigate = useNavigate();
  const filter = createFilterOptions();

  const { id } = useParams();
  const dispatch = useDispatch();
  const [Loader, setLoader] = useState(false);

  const DesignGroupNameList = useSelector((state) => state.DesignGroupNameList?.result);
  const ProductNameList = useSelector((state) => state.ProductNameList?.result);


  const hexToRGBFade = (hex, fade) => {
    hex = hex.replace("#", "");
    // Parse the red, green, and blue components from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGB value
    return `rgb(${r}, ${g}, ${b}, ${fade})`;
  };

  const sortByLabel = (obj1, obj2) => {
    let label1 = obj1.label?.toLowerCase();
    let label2 = obj2.label?.toLowerCase();

    if (label1 < label2) {
      return -1;
    }
    if (label1 > label2) {
      return 1;
    }
    return 0;
  };


  const DesignGroupList = DesignGroupNameList?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const ProductList = ProductNameList?.map((item) => ({
    value: item.id,
    label: item.product_name,
  }));

  const SaveVendor = async () => {
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Content-Type", "application/json");


    var rawData = CustomStringify({
      design_group: UserDetail?.result?.user?.design_group,
      product: UserDetail?.result?.user?.product,
      department: UserDetail?.result?.user?.department,
    });

    var requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: rawData,
      redirect: "follow",
    };

    fetch(`${API_URL}/sellers/${cmpdetail?.key}/${UserDetail?.result?.user?.id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success == true) {
          setLoader(false);
          showToast(result?.message, "success");
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };


  useEffect(() => {
    dispatch(fetchListDG(cmpdetail));
    dispatch(fetchListProd(cmpdetail));

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      function focusNextEmptyInput(currentIndex, inputs) {
        for (let i = currentIndex + 1; i < inputs.length; i++) {
          if (!inputs[i].value) {
            inputs[i].focus();
            return;
          }
        }
      }

      var inputs = document.querySelectorAll("input:enabled");

      inputs.forEach((input, index) => {
        input.addEventListener("focus", function (event) {
          if (event.target.type == "checkbox") {
            var nextIndex = index + 1;
            if (nextIndex < inputs?.length) {
              inputs[nextIndex].focus();
            }
          }
        });
        input.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
            if (
              event.target.id == "Mui-Autocomplete-IndustryType"
            ) {
              let itemMainButton = document.getElementById("itemMainButton");
              itemMainButton?.focus();
            } else if (
              event.target.id == "itemRemark" ||
              event.target.id == "itemDesignation" ||
              event.target.id == "L2WS1(%)" ||
              event.target.id == "itemAddress" ||
              event.target.id == "TDSDetails%"
            ) {
              let itemButton = document.getElementById("itemButton");
              itemButton?.focus();
            } else if (event.target.id.indexOf("Autocomplete") == -1) {
              focusNextEmptyInput(index, inputs);
            } else {
              if (event.target.ariaExpanded == "false") {
                focusNextEmptyInput(index, inputs);
              }
            }
          }
        });
      });
    }, 500);
  });

  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
      error: {
        main: "#212121",
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "16px",
            padding: "12px 8px 11px 8px",
            fontWeight: 500,
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "35px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-8px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-8px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "35px",
            padding: "0px 8px 0px 8px",
            fontWeight: 500,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            padding: 0,
            minHeight: 30,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            fontWeight: 500,
            padding: 0,
            minHeight: 30,
            "&.Mui-selected": {
              backgroundColor: Theme.primaryThemeColor,
              color: "white",
              borderRadius: "5px",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #9a9da1",
          },
          head: {
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
              zIndex: -1,
            },
            whiteSpace: "nowrap",
            width: "auto"
          },
          body: {
            whiteSpace: "nowrap",
            width: "auto"
          },
        },
      },
    },
  });

  return (
    <>
      <div className="main-box">
        <ThemeProvider theme={theme}>
          <div className="box-head d-flex justify-content-between align-items-center gap-1">
            <div className="d-flex align-items-center">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h6">Account</Typography>
            </div>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              {true ?
                <Button
                  id="itemMainButton"
                  onClick={SaveVendor}
                  variant="contained"
                >
                  Save
                </Button>
                : null}
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: 9999,
                }}
                open={Loader}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            </Box>
          </div>
          <div className="card-form-box">
            <Paper
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                overflowY: "scroll",
                "::-webkit-scrollbar": {
                  display: "none"
                },
                py: 1,
                transition: "0.5s ease-in-out"
              }}
            >
              <ThemeProvider theme={form}>
                <Grid
                  container
                  spacing={1.3}
                  columns={12}
                  sx={{ mt: 0.1, width: "100%", padding: "0 10px 0 10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_Name"
                      label="Account Name"
                      value={UserDetail?.result?.user?.company_name}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.company_name != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_Address"
                      label="Address"
                      value={UserDetail?.result?.user?.address}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.address != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_GSTNo"
                      label="GST No."
                      value={UserDetail?.result?.user?.GSTIN}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.GSTIN != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_Phone"
                      label="Phone No."
                      value={UserDetail?.result?.user?.mobile_no}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.mobile_no != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_state"
                      label="State"
                      value={UserDetail?.result?.user?.state}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.state != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_city"
                      label="City"
                      value={UserDetail?.result?.user?.city}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.city != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_broker"
                      label="Broker"
                      value={UserDetail?.result?.user?.broker}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.broker != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_transport"
                      label="Transport"
                      value={UserDetail?.result?.user?.transport}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.transport != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_pin_code"
                      label="PIN Code"
                      value={UserDetail?.result?.user?.pin_code}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.pin_code != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Led_msme_no"
                      label="MSME No."
                      value={UserDetail?.result?.user?.msme_no}
                      InputProps={{
                        readOnly: true,
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.msme_no != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Design_group"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Design Group" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Design_group"
                        value={{
                          value: UserDetail?.result?.user?.design_group,
                          label: UserDetail?.result?.user?.design_group,
                        }}
                        onChange={(event, newValue) => {
                          dispatch(editUserDetail({ name: "design_group", value: newValue.label }));
                        }}
                        options={DesignGroupList?.sort(sortByLabel)}
                        componentsProps={{ popper: { style: { width: '100vw', maxWidth: "500px" } } }}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        // filterOptions={(options, params) => {
                        //     const filtered = filter(options, params);
                        //     if (params.inputValue !== '' && filtered?.length < 1) {
                        //         filtered.push({
                        //             "label": `Add "${params.inputValue}"`,
                        //             "value": 0
                        //         });
                        //     }
                        //     return filtered;
                        // }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Design Group" />
                        )}
                      />)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Product"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Product Name" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Product"
                        value={{
                          value: UserDetail?.result?.user?.product,
                          label: UserDetail?.result?.user?.product,
                        }}
                        onChange={(event, newValue) => {
                          dispatch(editUserDetail({ name: "product", value: newValue.label }));
                        }}
                        options={ProductList?.sort(sortByLabel)}
                        componentsProps={{ popper: { style: { width: '100vw', maxWidth: "500px" } } }}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        // filterOptions={(options, params) => {
                        //     const filtered = filter(options, params);
                        //     if (params.inputValue !== '' && filtered?.length < 1) {
                        //         filtered.push({
                        //             "label": `Add "${params.inputValue}"`,
                        //             "value": 0
                        //         });
                        //     }
                        //     return filtered;
                        // }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Product" />
                        )}
                      />)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Design_department"
                      label="Department"
                      value={UserDetail?.result?.user?.department}
                      onChange={(e) => {
                        dispatch(editUserDetail({ name: "department", value: e.target.value }));
                      }}
                      InputLabelProps={{
                        shrink: UserDetail?.result?.user?.department != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                </Grid>
              </ThemeProvider>
            </Paper>
          </div>
        </ThemeProvider>
      </div>

      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
